import { createAsyncAction } from 'async-selector-kit'
import { API_PATH_PROFILE_UPDATE } from '../../../../config'
import { RootState } from '../../../../store'
import { ApiConfig, getLocalServerURL } from '../../../../utils/getApiConfig'
import { onIsLoading } from '../../../../utils/onLoading'
import { getPortalBootstrapForce } from '../../selectors/api/bootstrap'
import { onError } from '../../../../utils/onError'
import { onSuccess } from '../../../../utils/onSuccess'

export type StoreLike = {
  getState: () => RootState
  dispatch: (action: unknown) => void
}

/**
 * Core profile update logic. Exported for testing (success, error).
 */
export async function executeUpdateProfile(
  store: StoreLike,
  config: ApiConfig
): Promise<void> {
  const PATH = getLocalServerURL(API_PATH_PROFILE_UPDATE)
  onIsLoading(true)
  try {
    const response = await fetch(PATH, config)
    if (!response.ok) {
      onError('Failed to update profile')
      return
    }
    const data = await response.json()
    if (data?.messages?.resultCode === 'Ok') {
      setTimeout(async () => {
        await getPortalBootstrapForce(store.getState() as RootState)
      }, 2000)
      onSuccess('Successfully updated profile')
    } else {
      const error = data?.messages?.message?.[0]?.text || 'Unknown error'
      onError(error)
    }
  } finally {
    onIsLoading(false)
  }
}

export const [updateProfile, _, updateProfileError] = createAsyncAction(
  {
    id: 'update-profile',
    async: (store) => async (config: ApiConfig) => {
      await executeUpdateProfile(store, config)
    },
  },
  []
)
